import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { queryArticle } from "@/pages/api/art";
import Head from "next/head";
import styles from "./art.module.css";

interface ArticleData {
  title?: string;
  content?: string;
  fullScreen?: boolean;
  innerTitle?: string;
  shareSubTitle?: string;
}

const ArticlePage = () => {
  const router = useRouter();
  const { id, title: queryTitle, ownNav } = router.query;
  const [article, setArticle] = useState<ArticleData>({});
  const [showArticle, setShowArticle] = useState(false);

  useEffect(() => {
    if (!id) return;
    queryArticle({ code: id }).then((res: ArticleData) => {
      if (res) {
        setArticle(res);
        setShowArticle(true);
        if (res.shareSubTitle) {
          document.title = res.shareSubTitle;
        }
      }
    });
  }, [id]);

  return (
    <>
      <Head>
        <title>{article.title || queryTitle || ""}</title>
      </Head>
      <div className={styles.artPageWrap}>
        {/* 顶部导航栏（可选） */}
        {ownNav ? (
          <div
            style={{
              height: 44,
              background: "var(--theme-surface)",
              borderBottom: "1px solid var(--theme-border)",
              display: "flex",
              alignItems: "center",
              padding: "0 16px",
            }}
          >
            {article.title || queryTitle || ""}
          </div>
        ) : null}
        {/* 文章内容 */}
        {showArticle && (
          <article
            id="article"
            className={`${styles.artWrap} ${styles.artWrapCustomFont}`}
            style={{ padding: article.fullScreen ? "0px" : "16px" }}
            dangerouslySetInnerHTML={{ __html: article.content || "" }}
          />
        )}
      </div>
    </>
  );
};

export default ArticlePage;
